/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Press_ForbesInputs */

const en_onboarding_v1_press_forbes = /** @type {(inputs: Onboarding_V1_Press_ForbesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbes`)
};

const de_onboarding_v1_press_forbes = /** @type {(inputs: Onboarding_V1_Press_ForbesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbes`)
};

const pt_br2_onboarding_v1_press_forbes = /** @type {(inputs: Onboarding_V1_Press_ForbesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbes`)
};

const tr_onboarding_v1_press_forbes = /** @type {(inputs: Onboarding_V1_Press_ForbesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbes`)
};

const zh_cn2_onboarding_v1_press_forbes = /** @type {(inputs: Onboarding_V1_Press_ForbesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbes`)
};

const zh_hk2_onboarding_v1_press_forbes = /** @type {(inputs: Onboarding_V1_Press_ForbesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbes`)
};

const ko_kr2_onboarding_v1_press_forbes = /** @type {(inputs: Onboarding_V1_Press_ForbesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbes`)
};

const ru_ru2_onboarding_v1_press_forbes = /** @type {(inputs: Onboarding_V1_Press_ForbesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbes`)
};

const es_419_onboarding_v1_press_forbes = /** @type {(inputs: Onboarding_V1_Press_ForbesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbes`)
};

/**
* | output |
* | --- |
* | "Forbes" |
*
* @param {Onboarding_V1_Press_ForbesInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_press_forbes = /** @type {((inputs?: Onboarding_V1_Press_ForbesInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Press_ForbesInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_press_forbes(inputs)
	if (locale === "de") return de_onboarding_v1_press_forbes(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_press_forbes(inputs)
	if (locale === "tr") return tr_onboarding_v1_press_forbes(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_press_forbes(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_press_forbes(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_press_forbes(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_press_forbes(inputs)
	return es_419_onboarding_v1_press_forbes(inputs)
});